const { omit, pick, isEmpty } = require('lodash');

const { langs, currencies, countries, prefectures, shipmentFeeThreshold, } = require('../config');

const { entries } = Object;

const fields = () => {
  return {
    name: {
      label: '名称',
      type: 'string',
      validations: { required: (v) => !isEmpty(v) },
    },
    enName: {
      label: '名称(英語)',
      type: 'string',
    },
    productNameDisplayLang: {
      label: '商品名表示言語',
      type: 'select',
      options: entries(langs).map(([k, v]) => ({ value: k, label: v.label, })),
      validations: { required: (v) => !isEmpty(v) },
      initialValue: 'ja',
    },
    currency: {
      label: '通貨',
      type: 'select',
      options: entries(currencies).map(([k, v]) => ({ value: k, label: v.label, })),
      validations: { required: (v) => !isEmpty(v) },
      initialValue: 'jpy',
    },
    salesCountry: {
      label: '販売国',
      type: 'select',
      options: entries(countries).map(([k, v]) => ({ value: k, label: v.label, })),
      validations: { required: (v) => !isEmpty(v) },
      initialValue: 'jp',
    },
    path: {
      label: 'URLの固有文字列',
      type: 'string',
      validations: { required: (v) => !isEmpty(v) },
    },
    useSms: {
      label: 'SMSを使う',
      type: 'boolean',
    },
    useMobile: {
      label: 'モバイルアプリを使う',
      type: 'boolean',
    },
    useWms: {
      label: 'WMS機能を使う',
      type: 'boolean',
    },
    shipmentFeeThreshold: {
      label: '送料無料になる購入金額',
      type: 'integer',
      validations: {
        greaterThanOrEqualTo0: v => v == null || v >= 0,
      },
      hint: `未入力の場合はデフォルト値（${shipmentFeeThreshold}円）が使われます`,
    },
    phone: {
      type: 'string',
      inputType: 'tel',
      label: '電話番号',
      validations: {
        format: v => !v || v.match(/^(0{1}\d{9,10})$/),
      },
      placeholder: '08012345678 （ハイフンなし）'
    },
    postalCode: {
      type: 'string',
      label: '郵便番号',
      validations: {
        format: v => !v || (v || '').match(/^[0-9]{7}$/g),
      },
      inputProps: {
        type: 'tel',
      },
    },
    prefecture: {
      label: '都道府県',
      type: 'select',
      options: entries(prefectures).map(([k, v]) => ({ value: k, label: v })),
    },
    city: {
      type: 'string',
      label: '市区町村',
    },
    address1: {
      type: 'string',
      label: '町・番地',
    },
    address2: {
      type: 'string',
      label: 'マンション・ビル名',
    },
    bankTransferCommitteeCode: {
      label: '総合振込 振込依頼人コード（取引企業コード） ',
      type: 'string',
      validations: {
        format: v => !v || v.match(/^[0-9]{10}$/),
      },
      placeholder: '10桁の数字',
    },
    bankTransferCommitteeName: {
      label: '総合振込 振込依頼人名',
      type: 'string',
    },
    bankTransferBankCode: {
      label: '総合振込 仕向銀行番号',
      type: 'string',
      validations: {
        format: v => !v || v.match(/^[0-9]{4}$/),
      },
      placeholder: '4桁の数字',
    },
    bankTransferBranchCode: {
      label: '総合振込 仕向支店番号',
      type: 'string',
      validations: {
        format: v => !v || v.match(/^[0-9]{3}$/),
      },
      placeholder: '3桁の数字',
    },
    bankTransferAccountType: {
      label: '総合振込 預金種目',
      type: 'select',
      options: [
        { label: '普通', value: '1' },
        { label: '当座', value: '2' },
      ],
      initialValue: '1',
    },
    bankTransferAccountNumber: {
      label: '総合振込 口座番号',
      type: 'string',
      validations: {
        format: v => !v || v.match(/^[0-9]{7}$/),
      },
      placeholder: '7桁の数字',
    },
  };
};

module.exports = {
  fields,
  generalSettingsFields: () => {
    return {
      ...omit(fields(), ['path']),
    };
  },
};
